import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, withModifiers as _withModifiers, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2dced8c2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "selection-wrapper d-flex align-items-center gap-4 my-3 py-1 px-4" }
const _hoisted_2 = { class: "delivery-date-wrapper" }
const _hoisted_3 = {
  key: 0,
  class: "cta-create-order"
}
const _hoisted_4 = ["src"]
const _hoisted_5 = {
  key: 1,
  class: "cta-create-order"
}
const _hoisted_6 = ["src"]
const _hoisted_7 = { class: "d-flex align-items-center gap-4" }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { class: "delivered-icon" }
const _hoisted_10 = { class: "angle-icon" }
const _hoisted_11 = {
  key: 1,
  class: "asahi-mobile-information-container asahi-order-information-accordion w-100 fw-medium f-14"
}
const _hoisted_12 = {
  class: "accordion w-100",
  id: "asahi-order-information-accordion"
}
const _hoisted_13 = { class: "accordion-item" }
const _hoisted_14 = { class: "accordion-header w-100 d-flex align-items-center" }
const _hoisted_15 = { class: "row header-row align-items-start" }
const _hoisted_16 = {
  key: 0,
  class: "col-11 delivery-preferences-header"
}
const _hoisted_17 = { class: "text-white fw-bold delivery-preferences-title" }
const _hoisted_18 = { class: "text-white delivery-preferences-subtitle" }
const _hoisted_19 = {
  key: 1,
  class: "col-11 collapsed-mobile-view"
}
const _hoisted_20 = { class: "d-flex align-items-center gap-2 text-white fw-bold collapsed-mobile-header" }
const _hoisted_21 = ["src"]
const _hoisted_22 = { class: "transport-label" }
const _hoisted_23 = {
  key: 0,
  class: "exclamation-icon"
}
const _hoisted_24 = { class: "col-1 d-flex align-items-start justify-content-end" }
const _hoisted_25 = {
  id: 'asahi-order-information-accordion-collapse-' + 0,
  class: "accordion-collapse collapse w-100"
}
const _hoisted_26 = { class: "accordion-body pt-1" }
const _hoisted_27 = { class: "row" }
const _hoisted_28 = { class: "col-12 align-items-center justify-content-center" }
const _hoisted_29 = { class: "row align-items-center justify-content-center" }
const _hoisted_30 = { class: "col-12" }
const _hoisted_31 = { class: "row align-items-center justify-content-center" }
const _hoisted_32 = { class: "col-12 d-flex justify-content-center" }
const _hoisted_33 = {
  key: 0,
  class: "row align-items-center justify-content-center"
}
const _hoisted_34 = { class: "delivered-icon" }
const _hoisted_35 = { class: "row" }
const _hoisted_36 = { class: "col-12" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AsahiSelectHeader = _resolveComponent("AsahiSelectHeader")!
  const _component_DeliveryDatePicker = _resolveComponent("DeliveryDatePicker")!
  const _component_AsahiButton = _resolveComponent("AsahiButton")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_AsahiProgressBar = _resolveComponent("AsahiProgressBar")!
  const _component_DeliveredIcon = _resolveComponent("DeliveredIcon")!
  const _component_AngleUpDownIcon = _resolveComponent("AngleUpDownIcon")!
  const _component_ExclamationIcon = _resolveComponent("ExclamationIcon")!

  return (!_ctx.isMobile && !_ctx.isMoreSection)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass(["asahi-information-container px-5", {'has-delivery-exception': _ctx.hasAnyShipToException}])
      }, [
        _createElementVNode("div", _hoisted_1, [
          _createVNode(_component_AsahiSelectHeader, {
            modelValue: _ctx.selectedShipmentId ?? _ctx.shipToOptions[0]?.value,
            options: _ctx.shipToOptions,
            "onUpdate:modelValue": _ctx.setShipmentWrapper,
            icon: _ctx.shipToIcon,
            placeholder: _ctx.shipToOptions[0]?.label,
            isTicket: false,
            "is-white": true,
            "no-offset": true,
            isDatePickerOpen: _ctx.isDatePickerOpen,
            arrowColor: 'black',
            name: "asahi-order-information-set-shipment",
            "has-calendar-exception": _ctx.hasAnyShipToException,
            "calendar-exception-note": _ctx.$t('There has been a change in delivery for establishments marked in red. Click on the establishment to view the changes.')
          }, null, 8, ["modelValue", "options", "onUpdate:modelValue", "icon", "placeholder", "isDatePickerOpen", "has-calendar-exception", "calendar-exception-note"]),
          _createVNode(_component_AsahiSelectHeader, {
            modelValue: _ctx.selectedOrderType,
            options: _ctx.transportOptionsAsSelectBoxOptions,
            "onUpdate:modelValue": _ctx.onOrderTransportTypeSelectionWrapper,
            icon: _ctx.trackIcon,
            placeholder: _ctx.$t('Shipping method'),
            isTicket: false,
            "is-white": true,
            isDatePickerOpen: _ctx.isDatePickerOpen,
            arrowColor: 'black',
            name: "asahi-order-information-transport-type",
            "has-calendar-exception": _ctx.hasSelectedShipmentCalendarException,
            "calendar-exception-note": _ctx.$t('For the transport types marked in red, the delivery has changed. Click on the transport type to view the changes.')
          }, null, 8, ["modelValue", "options", "onUpdate:modelValue", "icon", "placeholder", "isDatePickerOpen", "has-calendar-exception", "calendar-exception-note"]),
          _createElementVNode("div", _hoisted_2, [
            (_openBlock(), _createBlock(_component_DeliveryDatePicker, {
              ref: "deliveryDatePickerRef",
              modelValue: _ctx.deliveryDateSelected,
              shipmentId: _ctx.selectedOrderType,
              placeholder: _ctx.$t('Request date'),
              holidayDays: _ctx.holidaysConfig,
              key: _ctx.deliveryDateSelected,
              "black-version": true,
              "onUpdate:modelValue": _ctx.onDateSelectionWrapper,
              onOpen: _ctx.handleDatePickerOpen,
              onClose: _ctx.handleDatePickerClose,
              "has-calendar-exception": _ctx.hasSelectedTransportCalendarException
            }, null, 8, ["modelValue", "shipmentId", "placeholder", "holidayDays", "onUpdate:modelValue", "onOpen", "onClose", "has-calendar-exception"]))
          ]),
          (_ctx.isCatalogVisible && _ctx.addToCartLabel && !_ctx.hideCta)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createVNode(_component_router_link, {
                  to: '/catalog/suggested-cart',
                  onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.navigateToPath({name: 'Create an order', label: _ctx.addToCartLabel, link: '/catalog/products' })), ["prevent"]))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_AsahiButton, {
                      class: "add-to-cart",
                      type: "secondary",
                      "no-wrap": false
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.addToCartLabel) + " ", 1),
                        _createElementVNode("img", {
                          src: _ctx.addToCartIcon,
                          alt: "Add to Cart",
                          class: "ms-2"
                        }, null, 8, _hoisted_4)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]))
            : _createCommentVNode("", true),
          (_ctx.showSuggestedCart && !_ctx.isOnSuggestedCart)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _createVNode(_component_router_link, {
                  to: '/catalog/suggested-cart',
                  onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.navigateToPath({name: 'Suggested Cart', label: _ctx.$t('Suggested Cart'), link: '/catalog/suggested-cart' })), ["prevent"]))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_AsahiButton, {
                      class: "add-to-cart",
                      type: "primary",
                      "no-wrap": false
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t('Suggested Cart')) + " ", 1),
                        _createElementVNode("img", {
                          src: _ctx.suggestedCartIcon,
                          alt: "Suggested Cart",
                          class: "ms-2"
                        }, null, 8, _hoisted_6)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", {
            class: _normalizeClass(["bottle-container", _ctx.messageColorClass?.borderColor])
          }, [
            _createVNode(_component_AsahiProgressBar, {
              percentage: _ctx.cashFilledPercentage,
              error: _ctx.errorWeight,
              success: _ctx.successWeight
            }, null, 8, ["percentage", "error", "success"])
          ], 2),
          (_ctx.hasAnyShipToException)
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                _createVNode(_component_AsahiButton, {
                  type: "red",
                  onClick: _ctx.displayCalendarExceptionModal
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("span", _hoisted_9, [
                      _createVNode(_component_DeliveredIcon)
                    ]),
                    _createTextVNode("   " + _toDisplayString(_ctx.$t('Delivery changes')) + "   ", 1),
                    _createElementVNode("span", _hoisted_10, [
                      _createVNode(_component_AngleUpDownIcon, { up: false })
                    ])
                  ]),
                  _: 1
                }, 8, ["onClick"])
              ]))
            : _createCommentVNode("", true)
        ])
      ], 2))
    : (_openBlock(), _createElementBlock("div", _hoisted_11, [
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("div", _hoisted_15, [
                (_ctx.isExpanded)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                      _createElementVNode("div", _hoisted_17, _toDisplayString(_ctx.$t('Delivery preferences')), 1),
                      _createElementVNode("div", _hoisted_18, _toDisplayString(_ctx.$t('Changing your delivery preferences may update the products shown')), 1)
                    ]))
                  : _createCommentVNode("", true),
                (!_ctx.isExpanded)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                      _createElementVNode("div", _hoisted_20, [
                        _createElementVNode("img", {
                          src: _ctx.whiteTruckIcon,
                          alt: "",
                          class: "truck-icon-white"
                        }, null, 8, _hoisted_21),
                        _createElementVNode("span", _hoisted_22, _toDisplayString(_ctx.currentShippingMethod?.label || _ctx.$t('Standard order')), 1),
                        (_ctx.showOrderWarning)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_23, [
                              _createVNode(_component_ExclamationIcon)
                            ]))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("div", {
                        class: _normalizeClass(["bottle-container", _ctx.messageColorClass?.borderColor])
                      }, [
                        _createVNode(_component_AsahiProgressBar, {
                          "is-white": true,
                          percentage: _ctx.cashFilledPercentage,
                          error: _ctx.errorWeight,
                          success: _ctx.successWeight,
                          "message-type": "mobile"
                        }, null, 8, ["percentage", "error", "success"])
                      ], 2)
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_24, [
                  _createElementVNode("button", {
                    class: "accordion-button collapsed",
                    type: "button",
                    "data-bs-toggle": "collapse",
                    "data-bs-target": '#asahi-order-information-accordion-collapse-' + 0,
                    "aria-expanded": "false",
                    "aria-controls": 'asahi-order-information-accordion-collapse-' + 0,
                    onClick: _cache[2] || (_cache[2] = (event) => _ctx.toggleAccordion(event))
                  })
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_25, [
              _createElementVNode("div", _hoisted_26, [
                _createElementVNode("div", _hoisted_27, [
                  _createElementVNode("div", _hoisted_28, [
                    _createVNode(_component_AsahiSelectHeader, {
                      modelValue: _ctx.selectedShipmentId ?? _ctx.shipToOptions[0]?.value,
                      options: _ctx.shipToOptions,
                      "onUpdate:modelValue": _ctx.setShipmentWrapper,
                      icon: _ctx.whiteShipToIcon,
                      placeholder: _ctx.shipToOptions[0]?.label,
                      "is-white": true,
                      "no-offset": true,
                      "is-mobile": true,
                      "selected-modal": false,
                      title: _ctx.$t('Ship to'),
                      name: "asahi-order-information-set-shipment",
                      "has-calendar-exception": _ctx.hasAnyShipToException,
                      "calendar-exception-note": _ctx.$t('There has been a change in delivery for establishments marked in red. Click on the establishment to view the changes.')
                    }, null, 8, ["modelValue", "options", "onUpdate:modelValue", "icon", "placeholder", "title", "has-calendar-exception", "calendar-exception-note"])
                  ])
                ]),
                _createElementVNode("div", _hoisted_29, [
                  _createElementVNode("div", _hoisted_30, [
                    _createVNode(_component_AsahiSelectHeader, {
                      modelValue: _ctx.selectedOrderType,
                      options: _ctx.transportOptionsAsSelectBoxOptions,
                      "onUpdate:modelValue": _ctx.onOrderTransportTypeSelectionWrapper,
                      icon: _ctx.whiteTruckIcon,
                      placeholder: _ctx.$t('Shipping method'),
                      "is-white": true,
                      "is-mobile": true,
                      "selected-modal": false,
                      title: _ctx.$t('Type of Transport'),
                      name: "asahi-order-information-transport-type",
                      "has-calendar-exception": _ctx.hasSelectedShipmentCalendarException,
                      "calendar-exception-note": _ctx.$t('For the transport types marked in red, the delivery has changed. Click on the transport type to view the changes.')
                    }, null, 8, ["modelValue", "options", "onUpdate:modelValue", "icon", "placeholder", "title", "has-calendar-exception", "calendar-exception-note"])
                  ])
                ]),
                _createElementVNode("div", _hoisted_31, [
                  _createElementVNode("div", _hoisted_32, [
                    _createVNode(_component_DeliveryDatePicker, {
                      ref: "deliveryDatePickerRef",
                      modelValue: _ctx.deliveryDateSelected,
                      shipmentId: _ctx.selectedOrderType,
                      placeholder: _ctx.$t('Request date'),
                      holidayDays: _ctx.holidaysConfig,
                      "is-mobile": true,
                      "onUpdate:modelValue": _ctx.onDateSelectionWrapper,
                      "has-calendar-exception": _ctx.hasSelectedTransportCalendarException
                    }, null, 8, ["modelValue", "shipmentId", "placeholder", "holidayDays", "onUpdate:modelValue", "has-calendar-exception"])
                  ]),
                  (_ctx.hasAnyShipToException)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                        _createVNode(_component_AsahiButton, {
                          type: "red",
                          onClick: _ctx.displayCalendarExceptionModal
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("span", _hoisted_34, [
                              _createVNode(_component_DeliveredIcon)
                            ]),
                            _createTextVNode("   " + _toDisplayString(_ctx.$t('Delivery changes')), 1)
                          ]),
                          _: 1
                        }, 8, ["onClick"])
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_35, [
                  _createElementVNode("div", _hoisted_36, [
                    _createVNode(_component_AsahiProgressBar, {
                      "is-white": true,
                      percentage: _ctx.cashFilledPercentage,
                      error: _ctx.errorWeight,
                      success: _ctx.successWeight,
                      "message-type": "mobile-long"
                    }, null, 8, ["percentage", "error", "success"])
                  ])
                ])
              ])
            ])
          ])
        ])
      ]))
}